(ns teamoesterreich.admin-mode.lebensretter.lr-user.modal.extend-modal
  (:require [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.admin-mode.lebensretter.detail.region-part :as region-part]
            [teamoesterreich.util.log :as log]))

(def REGIONS (txt/txt :fake :lr-regions))

(defn parse-date [date]
  ;(log/debug "parse date" date)
  (js/Date.parse (if date (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)) "1970")))

(defn date-conv [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  ;(log/debug "date-conv " date)
  (let [d (js/Date. (if (and (not (nil? date)) (> (count (str date)) 12)) (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)) "1970"))
        y (.getFullYear d)
        m (inc (.getMonth d))
        m (if (> m 9) m (str "0" m))
        d (.getDate d)
        d (if (> d 9) d (str "0" d))]
    (str y "-" m "-" d))
  )
(defn date-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" "120000.000Z"))




(defn modal [!actual-user !show]
  (let [!invalidate (r/cursor vstate/app-state [:lr-list :invalidate])
        !loaded (r/cursor vstate/app-state [:lr-list :loaded])
        lrClearances (filter :lrClearance-active (:user-lrClearance @!actual-user))
        wop-lrClearance (first (filter #(not (:lrClearance-valid %)) lrClearances))
        region_ (select-keys (reduce (fn [c e] (assoc c e true)) {} (clojure.string/split (:lrClearance-lrRegionHack wop-lrClearance) #"\|")) REGIONS)
        {:keys [user-uuid user-lastName user-firstName]} @!actual-user
        !st (r/atom {:changed? false
                     :region   nil
                     })
        !region (r/cursor !st [:region])
        training-doc (:lrClearance-trainingDocument wop-lrClearance)

        selfDeclaration-ok? (:userDocument-isSelfExplain (:lrClearance-selfExplainDocument wop-lrClearance))
        training-ok? training-doc

        ]
    (fn []
      (let [region-ok? (not-empty @!region)
            date-to-ok? (< (.getTime (new js/Date)) (parse-date  (or (:lrClearance-end @!st) (:userDocument-validTo training-doc))))]
        [mui/modal
         {
          :aria-labelledby  "simple-modal-title"
          :aria-describedby "simple-modal-description"
          :style            {:display        "flex"
                             :marginRight    "auto"
                             :marginLeft     "auto"
                             :alignItems     "center"
                             :justifyContent "center"}
          :open             (or @!show false)

          }


         [:div
          {
           :class "modal"
           :style {:width 750}}
          [mui/grid {:container  true
                     :direction  "row"
                     :justify    "space-between"
                     :alignItems "flex-start"}
           [mui/grid {:container false :item true :xs 12}
            [:h2 "Lebensretter Freigabe für `" user-firstName " " user-lastName "` verlängern!"]
            [:h4 "Qualifikationsnachweis: " (:userDocument-fileName training-doc) [:br] "gültig bis : " (date-conv (:userDocument-validTo training-doc))]

            ]

           [mui/grid {:container false :item true
                      :xs        6
                      :style     {}}



            [mui/text-field {
                             :style        {:background-color (if (not= (:lrClearance-end @!st) (:lrClearance-end wop-lrClearance)) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :type         "date"
                             :autoOk       true
                             :onChange     (fn [e] (swap! !st assoc :lrClearance-end (date-conv-back (h/event-value e))))
                             :label        (str "Gültig bis ")
                             :defaultValue (date-conv (or (:lrClearance-end @!st) (:userDocument-validTo training-doc)))
                             }]]


           [mui/grid {:container false :item true :xs 12} [:div]]




           [mui/grid {:container false :item true :xs 6}
            [mui/button
             {:variant   "contained"
              :startIcon (r/as-element [keyboard-arrow-left])
              :style     {:marginRight 50}
              :onClick   #(reset! !show false)
              }
             "Abbrechen"]]

           [mui/grid {:container false :item true :xs 6}
            (if (and
                  (not= "" (str (:lrClearance-type @!st)))
                  selfDeclaration-ok? training-ok? date-to-ok? region-ok?
                  )

              [mui/button
               {:color     "primary"
                :style     {:float "right"}
                :variant   "contained"
                :startIcon (r/as-element [save])
                :onClick   (fn [] (d-lrClearance/>user-add-edit-clearance (:user-uuid @!actual-user)
                                                                   (merge {:lrClearance-type         (or (:lrClearance-type @!st) "EH")
                                                                           :lrClearance-end          (or (:lrClearance-end @!st) (:userDocument-validTo training-doc))
                                                                           :lrClearance-lrRegionHack (reduce (fn [c [k v]] (if v (str c "|" k) c)) "" @!region)
                                                                           }
                                                                          )
                                                                   (fn []
                                                                     (d-lrClearance/>extend-clearance (:lrClearance-uuid wop-lrClearance)
                                                                                                 {:lrClearance-valid true}
                                                                                                 (fn []
                                                                                                   (d-user/actual-user-invalidate !actual-user)
                                                                                                   (reset! !loaded nil)
                                                                                                   (reset! !show false)
                                                                                                   )))
                                                                   ))
                }
               "Bestätigen"]
              [:span
               (when (= "" (str (:lrClearance-type @!st))) [mui/chip {:color "primary" :label "Qualifiziert durch fehlt"}])
               (when-not region-ok? [mui/chip {:color "primary" :label "Regionen nicht gewählt"}])
               (when-not date-to-ok? [mui/chip {:color "primary" :label "`Gültig bis` ist ungültig"}])
               (when-not (:user-profileValid @!actual-user) [mui/chip {:color "primary" :label "Profil nicht vollständig"}])

               ])]
           ]]]
        ))))





(defn get-user-details [!actual-user tomId]
  (d-user/get-user-all tomId (fn [data] (reset! !actual-user data)))
  )

(defn modal-by-tomId [!tomId]
  (let [!actual-user (r/atom {})]
    (fn []
      (let [user @!actual-user
            tomId @!tomId
            lrClearances (filter :lrClearance-active (:user-lrClearance @!actual-user))
            wop-clearance (first (filter #(not (:lrClearance-valid %)) lrClearances))

            wop-identity-document (:lrClearance-identityDocument wop-clearance)
            proposed-identity-document (or wop-identity-document (first (filter (fn [{active :userDocument-active isIdentity :userDocument-isIdentity}] (and active isIdentity)) (:user-userDocument @!actual-user))))
            proposed-identity-document (or proposed-identity-document (first (filter (fn [{active :userDocument-active type :userDocument-type}] (and active (= type "identification"))) (:user-userDocument @!actual-user))))

            wop-selfDeclaration-document (:lrClearance-selfExplainDocument wop-clearance)
            proposed-selfDeclaration-document (or wop-selfDeclaration-document (first (filter (fn [{active :userDocument-active isSelfExplain :userDocument-isSelfExplain}] (and active isSelfExplain)) (:user-userDocument @!actual-user))))
            proposed-selfDeclaration-document (or proposed-selfDeclaration-document (first (filter (fn [{active :userDocument-active type :userDocument-type}] (and active (= type "selfDeclaration"))) (:user-userDocument @!actual-user))))

            wop-training-document (:lrClearance-trainingDocument wop-clearance)
            proposed-training-document (or wop-training-document (first (filter (fn [{active :userDocument-active isTraining :userDocument-isTraining}] (and active isTraining)) (:user-userDocument @!actual-user))))
            proposed-training-document (or proposed-training-document (first (filter (fn [{active :userDocument-active type :userDocument-type}] (and active (= type "first-aid-certificate"))) (:user-userDocument @!actual-user))))

            ]
        ;(js/console.log "render clearance modal-by-tomId " tomId (clj->js proposed-identity-document) (clj->js proposed-selfDeclaration-document) (clj->js proposed-training-document))
        (when (and (pos? tomId) (not= tomId (:reqTomId user)))
          (get-user-details !actual-user tomId))
        (when (and (:user-uuid @!actual-user)
                   (or (not wop-clearance)
                       (not wop-identity-document)
                       (not wop-selfDeclaration-document)
                       (not wop-training-document)
                       )) (d-lrClearance/>user-add-edit-clearance (:user-uuid @!actual-user)
                                                           (merge {}
                                                                  (when-let [e (:userDocument-type proposed-identity-document)] [:lrClearance-type e])
                                                                  (when-let [e (:userDocument-validFrom proposed-identity-document)] [:lrClearance-start e])
                                                                  (when-let [e (:userDocument-validTo proposed-identity-document)] [:userDocument-validTo e])
                                                                  (when-let [e (:userDocument-uuid proposed-identity-document)] [:_identityDocument-uuid e])
                                                                  (when-let [e (:userDocument-uuid proposed-selfDeclaration-document)] [:_selfDeclarationDocument-uuid e])
                                                                  (when-let [e (:userDocument-uuid proposed-training-document)] [:_trainingDocument-uuid e])
                                                                  )
                                                           (fn [])))
        (if (or (not= @!tomId (:reqTomId user))
                (:error user))
          ;no data
          [mui/modal
           {:aria-labelledby  "simple-modal-title"
            :aria-describedby "simple-modal-description"
            :style            {:display        "flex"
                               :marginRight    "auto"
                               :marginLeft     "auto"
                               :alignItems     "center"
                               :justifyContent "center"}
            :open             (pos? tomId)
            :onClose          (fn []
                                (reset! !actual-user {})
                                (reset! !tomId nil))
            }
           [:div
            {:class "modal"
             :style {:width 400}}

            [:h4 (str "Freigabe verlängern: " tomId)]
            [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
            [mui/typography "Lade den Datensatz ... "]
            [mui/typography {:color "primary"} (:error user)]
            [:br]
            [mui/button
             {:color    "primary"
              :variant  "contained"
              :on-click (fn []
                          (reset! !actual-user {})
                          (reset! !tomId {}))
              }
             "Schließen"]
            ]]
          ;has data
          (modal !actual-user !tomId)

          )
        ))))